import api from "../../store/services/api";

export const getAllStats = (params) =>
  api.get(`/report/restaurant-stats/`, { params });

const OrderStatsReportService = {
  getAllStats,
};

export default OrderStatsReportService;
